// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__4UV2v","boxTitle":"Qualiphy_boxTitle__1wsw4","box":"Qualiphy_box__S_Ea-","toggleWrap":"Qualiphy_toggleWrap__1WJDu"};